// KnowledgeHubArticleDetailPage.tsx
import useCustomNavigate from "../../../../hooks/useCustomNavigate";
import useIsMobile from "../../../../hooks/useIsMobile";
import { useTranslation } from 'react-i18next';
import { StyledContainer, Divider, BottomContainer } from "./article-detail-page.styles";
import MoreArticles from "../../../../components/articles/more-articles";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import InheritancePlanningArticle from "../../../../components/articles/4/inheritance-planning-article";
import RentalManagementArticle from "../../../../components/articles/2/rental-management-article";
import HandoverChecklistArticle from "../../../../components/articles/1/handover-checklist-article";
import FindTenantArticle from "../../../../components/articles/3/find-tenant-article";
import BankAccountInDubaiArticle from "../../../../components/articles/5/bank-account-in-dubai-article";
import AppraisalArticle from "../../../../components/articles/6/appraisal-article";
import TabBar from "../../components/tab-bar/tab-bar";
import Footer from "../../components/footer/footer";
import { Capacitor } from '@capacitor/core';
import { Clipboard } from '@capacitor/clipboard';

const KnowledgeHubArticleDetailPage = () => {
    const navigate = useCustomNavigate();
    const isMobile = useIsMobile();
    const { id } = useParams<{ id: string }>();
    const { t } = useTranslation();

    // Functions
    const handleShareClick = useCallback(() => {
        const currentUrl = window.location.href;

        if (isMobile && navigator.share) {
            // Use the Web Share API for mobile devices
            navigator.share({
                title: document.title,
                text: t("articles.share_text"),
                url: currentUrl,
            })
                .then(() => {
                    console.log("Successful share");
                })
                .catch((error) => {
                    console.error("Error sharing:", error);
                });
        } else {
            // Check if running in Capacitor environment
            if (Capacitor.isNativePlatform()) {
                // Use Capacitor's Clipboard API
                Clipboard.write({
                    string: currentUrl
                }).then(() => {
                    alert(t("articles.link_copied"));
                }).catch((err: Error) => {
                    console.error("Failed to copy the link using Capacitor:", err);
                });
            } else if (navigator.clipboard && navigator.clipboard.writeText) {
                // Use browser's Clipboard API if available
                navigator.clipboard.writeText(currentUrl)
                    .then(() => {
                        alert(t("articles.link_copied"));
                    })
                    .catch((err) => {
                        console.error("Failed to copy the link:", err);
                    });
            } else {
                // Fallback for browsers without clipboard support
                console.error("Clipboard API not available");
                alert(t("articles.copy_not_available"));
            }
        }
    }, [isMobile]);

    // Render specific article content based on the id in the URL
    const renderArticleContent = useCallback(() => {
        switch (id) {
            case "1":
                return <HandoverChecklistArticle onClickShare={handleShareClick} />;
            case "2":
                return <RentalManagementArticle onClickShare={handleShareClick} />;
            case "3":
                return <FindTenantArticle onClickShare={handleShareClick} />;
            case "4":
                return <InheritancePlanningArticle onClickShare={handleShareClick} />;
            case "5":
                return <BankAccountInDubaiArticle onClickShare={handleShareClick} />;
            case "6":
                return <AppraisalArticle onClickShare={handleShareClick} />;
            default:
                return <p style={{ paddingLeft: 54, paddingRight: 54 }}>{t("articles.article_not_found")}</p>;
        }
    }, [id]);

    return (
        <div style={{ backgroundColor: "white" }}>
            <TabBar isDefaultSticky />

            <StyledContainer>
                {renderArticleContent()}
            </StyledContainer>

            <BottomContainer>
                <Divider />

                <MoreArticles currentVisibleArticleId={Number(id)} onClickReadNextArticle={(articleId: number) => navigate(`/articles/${articleId}`)} />
            </BottomContainer>

            <Footer />
        </div>
    );
};

export default KnowledgeHubArticleDetailPage;
